import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';

export const VacancyCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput 
        source="title" 
        validate={[required()]} 
        fullWidth 
      />
      <TextInput 
        source="description" 
        validate={[required()]} 
        multiline
        rows={4}
        fullWidth 
      />
      <TextInput 
        source="externalUrl" 
        fullWidth 
      />
      <TextInput 
        source="experience" 
        fullWidth 
      />
      <SelectInput 
        source="employment" 
        validate={[required()]}
        choices={[
          { id: 'FULL_TIME', name: 'Полная занятость' },
          { id: 'PART_TIME', name: 'Частичная занятость' },
        ]}
      />
      <TextInput 
        source="schedule" 
        fullWidth 
      />
      <TextInput 
        source="salary" 
        fullWidth 
      />
      <ReferenceInput source="categoryId" reference="vacancy-categories">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <BooleanInput 
        source="isActive" 
        defaultValue={true} 
      />
      <NumberInput 
        source="sortOrder" 
        defaultValue={0}
        min={0}
      />
    </SimpleForm>
  </Create>
);
